export var FlowRestRequestBodyFormat;
(function (FlowRestRequestBodyFormat) {
    FlowRestRequestBodyFormat["None"] = "None";
    FlowRestRequestBodyFormat["RawJson"] = "RawJson";
    FlowRestRequestBodyFormat["FormUrlEncoded"] = "FormUrlEncoded";
})(FlowRestRequestBodyFormat || (FlowRestRequestBodyFormat = {}));
export var FlowRestResponseBodyFormat;
(function (FlowRestResponseBodyFormat) {
    FlowRestResponseBodyFormat["AutoDetect"] = "AutoDetect";
    FlowRestResponseBodyFormat["ParsedBase64"] = "ParsedBase64";
})(FlowRestResponseBodyFormat || (FlowRestResponseBodyFormat = {}));
//# sourceMappingURL=bodyFormat.js.map